
import { ResultsDTO } from "Types";
import { LoginRequest } from "Interface";
import { ApiService } from "Services/ApiService";


export const AdminAuthApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    adminLogin: builder.mutation<ResultsDTO, Partial<LoginRequest>>({
      query: (credentials) => ({
        url: "/auth/login-with-password",
        method: "POST",
        body: {
          ...credentials,
          loginType: "adminlogin", 
        },
      }),
    }),
  }),
});

export const { useAdminLoginMutation } = AdminAuthApiSlice;
